export const GOOGLE_MAP_API_KEY = "AIzaSyAwWgamvwx7aZk9xRcPtHGnLDXU_ydN-zQ";
export const ENTERPRISE_API_URL = "https://enterprise-api.shipday.com";
export const STRIPE_KEY = "pk_live_goDpxfRC7Z3f2CVPmuUsAX6Q00GAYHagBy";
export const GOOGLE_MAP_ID = "1a9e3029635e0820da9dc6e9";
// When true, every enterprise gets the ClickHouse-backed analytics view + APIs.
// When false, every enterprise falls back to the traditional reporting view + APIs.
export const USE_CLICKHOUSE_ANALYTICS = true;
